/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {ExchangeSessionTokenRequest} from '@cash-web/protos/squareup/cash/janus/api/ExchangeSessionTokenProto.pb'
import {ExchangeSessionTokenResponse} from '@cash-web/protos/squareup/cash/janus/api/ExchangeSessionTokenProto.pb'


export const exchangeSessionToken = (request: ExchangeSessionTokenRequest, options?: CashRequestOptions) => post<ExchangeSessionTokenRequest, ExchangeSessionTokenResponse>("/cash-app/security/1.0/exchange-session-token", request, {...options, rejectOnError: true })